import { Controller } from "@hotwired/stimulus";
import { application } from "src/stimulus/application";

// landIeul: components/domainParts/ScrollBtn。
// scrollY が #ActiveLine〜#DisableLine の間のときだけボタンを表示し、
// クリックで #ScrollTo へ smooth scroll する (offset -50)。SP 限定は CSS 側で制御。
class SiteSharedScrollBtnController extends Controller<HTMLElement> {
  private readonly update = (): void => {
    const activeLine = document.getElementById("ActiveLine");
    const disableLine = document.getElementById("DisableLine");
    if (!activeLine || !disableLine) return;
    const activePoint = activeLine.getBoundingClientRect().top + window.scrollY;
    const disablePoint = disableLine.getBoundingClientRect().top + window.scrollY;
    const isActive = window.scrollY > activePoint && window.scrollY < disablePoint;
    // 非 active は inline display:none、active は CSS に委譲 (PC: none / SP: block)
    this.element.style.display = isActive ? "" : "none";
  };

  connect(): void {
    window.addEventListener("scroll", this.update);
    window.addEventListener("resize", this.update);
    this.update();
  }

  disconnect(): void {
    window.removeEventListener("scroll", this.update);
    window.removeEventListener("resize", this.update);
  }

  scrollToTarget(): void {
    const target = document.getElementById("ScrollTo");
    if (!target) return;
    const top = target.getBoundingClientRect().top + window.scrollY - 50;
    window.scrollTo({ top, behavior: "smooth" });
  }
}

application.register("site--shared--scroll-btn", SiteSharedScrollBtnController);
